import {naturalSort} from '@benchling/js-utils';
import React from 'react';

import {Capability} from 'auth/capabilities/CapabilityFeatureConstants';
import isCapabilityEnabledForTenant from 'auth/capabilities/isCapabilityEnabledForTenant';
import BenchlingConfig from 'BenchlingConfig';

import SchemaPoliciesListing from './SchemaPoliciesListing';

export default function SchemaPoliciesPoliciesTab(): JSX.Element {
  const DISPLAY_NAME_TO_IS_ENABLED: {[key: string]: boolean} = {
    Connection: isCapabilityEnabledForTenant(Capability.LAB_AUTOMATION) && BenchlingConfig.INSTRUMENTS_ENABLE,
    Entity: true,
    Result: BenchlingConfig.PERMISSIONS_ENABLE_ASSAY_SCHEMA_PERMISSIONS,
    Request: BenchlingConfig.PERMISSIONS_ENABLE_ASSAY_SCHEMA_REQUEST_PERMISSIONS,
    Run: BenchlingConfig.PERMISSIONS_ENABLE_ASSAY_SCHEMA_PERMISSIONS,
    Fieldset: true,
    'Workflow Task':
      BenchlingConfig.PERMISSIONS_ENABLE_PROCESS_SCHEMAS_ACCESS_POLICIES_UI &&
      BenchlingConfig.WORKFLOWS_ENABLE,
  };
  const schemas = naturalSort(
    Object.keys(DISPLAY_NAME_TO_IS_ENABLED).filter(
      (displayName: keyof typeof DISPLAY_NAME_TO_IS_ENABLED) => DISPLAY_NAME_TO_IS_ENABLED[displayName]
    )
  );

  const schemasString = schemas.reduce((previousValue: string, currentValue: string, index: number) => {
    if (index === 0) {
      return currentValue;
    } else if (index !== schemas.length - 1) {
      return `${previousValue}, ${currentValue}`;
    }
    return `${previousValue} and ${currentValue}`;
  }, '');
  return (
    <>
      <p>
        Assign Schema Access Policies to control how users interact with schema definitions and their objects.
        Schema Access Policies work in conjunction with Registry and Project permissions to provide specific
        control over the information users have access to.
      </p>
      <p>
        All users of an organization have default access to all schemas associated with that organization.
        Default access means that users can view schema definitions and their objects. Granting additional
        Schema Access Policies will control where schemas are listed in the product, who can create and edit
        schema objects, and who can manage schema access.
      </p>
      <p>
        {' '}
        At this time, Schema Access Policies only apply to {schemasString} Schemas.{' '}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://help.benchling.com/hc/articles/9684210957581"
        >
          Learn more
        </a>
      </p>

      <div className="u-spacing-top">
        <SchemaPoliciesListing />
      </div>
    </>
  );
}
